import { useMemo } from 'react'

import { ResponseThread } from '@/schema'

interface UseCommentAvatarsParams {
  documentVersionId: string | undefined
  showCommentAvatars: boolean
  activeCommentId: string | undefined
  commentsByDocVersion: Record<string, Record<string, ResponseThread>>
  annotationsByDocVersion: Record<string, Record<string, any>>
  isActive: boolean
}

export const useCommentAvatars = ({
  documentVersionId,
  showCommentAvatars,
  activeCommentId,
  commentsByDocVersion,
  annotationsByDocVersion,
  isActive,
}: UseCommentAvatarsParams) => {
  const avatars = useMemo(() => {
    if (!documentVersionId || !showCommentAvatars) return []

    const commentsById = commentsByDocVersion[documentVersionId] ?? {}
    const annotationsByCommentId =
      annotationsByDocVersion[documentVersionId] ?? {}

    return Object.entries(commentsById)
      .map(([commentId, comment]) => {
        const metadata = annotationsByCommentId[commentId]
        if (!metadata) return null

        return {
          commentId,
          comment,
          metadata,
          isActive: activeCommentId === commentId,
        }
      })
      .filter((avatar): avatar is NonNullable<typeof avatar> => avatar !== null)
  }, [
    commentsByDocVersion,
    annotationsByDocVersion,
    activeCommentId,
    documentVersionId,
    showCommentAvatars,
  ])

  return {
    avatars: isActive ? (avatars as any) : [],
  }
}
